import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthState from "../Services/Auth/state.js";
import AdminState from "../Services/Admin/state.js";
import PrivateRoute from "./PrivateRoutes";
import LoginPage from "../Pages/Auth/Login";
import MasterPage from "../Pages/Master/index.js";
import DashboardPage from "../Pages/Dashboard/index.js";
import ProjectPage from "../Pages/Project/index.js";
import InformationPage from "../Pages/Information/index.js";
import ProjectClosed from "../Pages/ProjectClose/index.js";
import ProjectPointsLeaderboard from "../Pages/Points/index.js";
import SupervisorAndSuperAdminRoute from "../Layouts/SupervisorAndSuperAdminRoute.js";
import SuperAdminRoute from "../Layouts/SuperAdminRoute.js";

const AppRoutes = () => {
	return (
		<AuthState>
			<AdminState>
				<BrowserRouter>
					<Routes>
						<Route>
							<Route path="/" element={<LoginPage />} />
							<Route path="login" element={<LoginPage />} />

							<Route element={<PrivateRoute />}>
								{/* <Route
									path="master/incentive"
									element={
										<SuperAdminRoute>
											<MasterPage />
										</SuperAdminRoute>
									}
								/> */}
								<Route
									path="master/:tab"
									element={
										<SupervisorAndSuperAdminRoute>
											<MasterPage />
										</SupervisorAndSuperAdminRoute>
									}
								/>
								<Route path="dashboard" element={<DashboardPage />} />
								<Route path="project" element={<ProjectPage />} />
								<Route path="project-close" element={<ProjectClosed />} />
								<Route
									path="points"
									element={
										<SuperAdminRoute>
											<ProjectPointsLeaderboard />
										</SuperAdminRoute>
									}
								/>
								<Route path="information" element={<InformationPage />} />
							</Route>
						</Route>
					</Routes>
				</BrowserRouter>
				<ToastContainer />
			</AdminState>
		</AuthState>
	);
};

export default AppRoutes;
